import React from 'react';
import Image from '@atlaskit/image';
import { token } from '@atlaskit/tokens';
import type { FormatMessage } from '@atlassian/jira-shared-types/src/general.tsx';
import HighIcon from './assets/high-priority.svg';
import HighestIcon from './assets/highest-priority.svg';
import LowIcon from './assets/low-priority.svg';
import LowestIcon from './assets/lowest-priority.svg';
import MediumIcon from './assets/medium-priority.svg';
import { messages } from './messages.tsx';
import type { Priorities } from './types.tsx';

export const getPriorities = (formatMessage: FormatMessage): Priorities => ({
	P1: {
		ogPriority: 'P1',
		bgColor: token('color.icon.danger'),
		jiraPriority: formatMessage(messages.highestPriorityNonFinal),
		Icon: <Image src={HighestIcon} alt="" />,
	},
	P2: {
		ogPriority: 'P2',
		bgColor: token('color.background.accent.red.subtle'),
		jiraPriority: formatMessage(messages.highPriorityNonFinal),
		Icon: <Image src={HighIcon} alt="" />,
	},
	P3: {
		ogPriority: 'P3',
		bgColor: token('color.background.accent.orange.subtle'),
		jiraPriority: formatMessage(messages.mediumPriorityNonFinal),
		Icon: <Image src={MediumIcon} alt="" />,
	},
	P4: {
		ogPriority: 'P4',
		bgColor: token('color.background.accent.green.subtle'),
		jiraPriority: formatMessage(messages.lowPriorityNonFinal),
		Icon: <Image src={LowIcon} alt="" />,
	},
	P5: {
		ogPriority: 'P5',
		bgColor: token('color.background.accent.green.bolder'),
		jiraPriority: formatMessage(messages.lowestPriorityNonFinal),
		Icon: <Image src={LowestIcon} alt="" />,
	},
});
